import { Injectable } from '@angular/core';
import { BehaviorSubject, delay, Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http';
import { environment } from "../../environments/environment"

@Injectable({
  providedIn: 'root'
})
export class HotelCityService {
countryList:any[]=[]
  private message = new BehaviorSubject('default message');
  portMessage = this.message.asObservable();

  deliverMsg(message: any) {
   // console.log(message)
    this.message.next(message)
  }

  cityLoadSubDom! : Subject<any|undefined>;
  cityLoadSubInt! : Subject<any|undefined>;

  hotelCountries : any=undefined;
  citiesLoad : {popularDomesticLoad : boolean,
    popularInternationalLoad : boolean,
    otherDomesticLoad : boolean,
    otherInternationalLoad : boolean
  } = {
    popularDomesticLoad:false,popularInternationalLoad:false,otherDomesticLoad:false,otherInternationalLoad:false
  }
  hotelCities : any[]=[];
  hotelCitiesDomestic : any[]=[];
  hotelCitiesInternational : any[]=[];
  countryLoadSub : Subject<any>

  constructor(private http : HttpClient) { 
    this.countryLoadSub=new Subject();
    this.cityLoadSubDom = new  Subject<any>();
    this.cityLoadSubInt = new  Subject<any>();
    //this.subCountryLoad();
  }
  
  getCityLoadDomesticSub() {
    return this.cityLoadSubDom.asObservable();
  }

  getCityLoadInternationalSub() {
    return this.cityLoadSubInt.asObservable();
  }

  loadPopularCities() {
    if(!this.citiesLoad.popularDomesticLoad) {
      this.getCitiesApi({type : "D",popularityRank : 1}).subscribe({next : (cities : any) => {
        cities.forEach((city:any) => {
          if(this.hotelCitiesDomestic.length>0) {
            this.hotelCitiesDomestic[0]=[...this.hotelCitiesDomestic[0],...city];
          } else {
            this.hotelCitiesDomestic.push(city);
          }
          
        });
        this.citiesLoad.popularDomesticLoad=true;
        this.cityLoadSubDom?.next(this.citiesLoad);
      },error : (err : any)=> {
        console.error("Error to get domestic popular cities - ",err);
      }})
    }
    if(!this.citiesLoad.popularInternationalLoad) {
      this.getCitiesApi({type : "I",popularityRank : 1}).subscribe({next : (cities : any) => {
        cities.forEach((city:any) => {
          if(this.hotelCitiesInternational.length>0) {
            this.hotelCitiesInternational[0]=[...this.hotelCitiesDomestic[0],...city];
          } else {
            this.hotelCitiesInternational.push(city);
          }
        });
        this.citiesLoad.popularInternationalLoad=true;
        this.cityLoadSubInt.next(this.citiesLoad);
      },error : (err : any)=> {
        console.error("Error to get domestic popular cities - ",err);
      }})
    }

  }

  loadOtherCities() {
    if(!this.citiesLoad.otherDomesticLoad) {
      this.getCitiesApi({type : "D",popularityRank : 10}).subscribe({next : (cities : any) => {
        cities.forEach((city:any) => {
          if(this.hotelCitiesDomestic.length>0) {
            if(city && city.length>0) {
              this.hotelCitiesDomestic[0]=[...this.hotelCitiesDomestic[0],...city];
            }
          } else {
            this.hotelCitiesDomestic?.push(city);
          }
        });
        this.citiesLoad.otherDomesticLoad=true;
        this.cityLoadSubDom.next(this.citiesLoad);
      },error : (err : any)=> {
        console.error("Error to get domestic popular cities - ",err);
      }})
    }
    if(!this.citiesLoad.otherInternationalLoad) {
      this.getCitiesApi({type : "I",popularityRank : 10}).subscribe({next : (cities : any) => {
        cities.forEach((city:any) => {
          if(this.hotelCitiesInternational.length>0) {
            if(city && city.length>0) {
              this.hotelCitiesInternational[0]=[...this.hotelCitiesInternational[0],...city];
            }
          } else {
            this.hotelCitiesInternational?.push(city);
          }
        });
        this.citiesLoad.otherInternationalLoad=true;
        this.cityLoadSubInt.next(this.citiesLoad);
      },error : (err : any)=> {
        console.error("Error to get domestic popular cities - ",err);
      }})
    }

  }

  loadCity() {
    if(!this.hotelCountries) {
      this.http.post( environment.API_URL+"/api/product/hotel/_countries" ,{ observe : "body",responseType : "json"})
      .subscribe((itm) => {
        let item:any=itm
        this.hotelCountries=item.map((c:any) => { return {country : c,cityLoad : false}});
        this.countryLoadSub.next({});
      })
    }
  }

  subCountryLoad() {
    this.countryLoadSub.asObservable().subscribe(()=> {
      this.loadCities();
    })



    
  }
  loadGoogleCity(searchText:any,city:any) {
    let httpParam : HttpParams=new HttpParams();
      httpParam=httpParam.append("searchtext", searchText);
      if(city){
        httpParam=httpParam.append("type", city);

      }

   return this.http.get( environment.API_URL+"/api/places" ,{ observe : "body", params : httpParam,responseType : "json"})  

    }

    selectGoogleCity(place_id:any) {
      let httpParam : HttpParams=new HttpParams();
        httpParam=httpParam.append("place_id", place_id);
     return this.http.get( environment.API_URL+"/api/place-address" ,{ observe : "body", params : httpParam,responseType : "json"})  
  
      }
  


  loadCities() {
    let x=0;
    if(this.hotelCountries) {
      let countryCodeParts:any[]=[];
      const cityLoadCountries = this.hotelCountries.filter((itm:any) => !itm.cityLoad);
      while(x<cityLoadCountries.length) {
        let lastIdx = (x+2)<(cityLoadCountries.length-1) ? (x+2) : (cityLoadCountries.length-1);
        countryCodeParts.push({startIdx : x,lastIdx:lastIdx});
        x=lastIdx+1;
      }
      countryCodeParts.forEach((countryCodePart:any) => {
        const slicedCountries : any = cityLoadCountries?.slice(countryCodePart.startIdx,countryCodePart.lastIdx);
        const countryCodes =slicedCountries.map((itm: any)=>itm.country);
        const apiParam = countryCodes.join(",");
        this.getCitiesApi(apiParam).subscribe((cities:any) => {
          cities.forEach((city:any) => {
            this.hotelCities?.push(city);
            for(let counter = countryCodePart.startIdx;counter<=countryCodePart.lastIdx;) {
              this.hotelCountries.cityLoaded=true;
            }
          })
          
        });
        delay(1000);
      })
    }
  }

  getCitiesApi(param : {countryCode? : string,type? : string,popularityRank? : number})  {
    let reqBody : any={};
    if(param.countryCode) reqBody.country=param.countryCode;
    if(param.type) reqBody.type=param.type;
    if(param.popularityRank) reqBody.rank=param.popularityRank;
    return this.http.post(environment.API_URL + "/api/product/hotel/_cities", reqBody);
  }


}
